export const isEmpty = (obj: object | undefined) => {
    if (obj === undefined) return true;
    for (const prop in obj) if (Object.hasOwn(obj, prop)) return false;
    return true;
};

export const removeEmpty = (o: object) =>
    Object.fromEntries(Object.entries(o).filter(([, v]) => v !== null && v !== '' && v !== undefined));

export const trimValues = (o: object) =>
    Object.fromEntries(
        Object.entries(o).map(([key, value]) => [key, typeof value === 'string' ? value.trim() : value]),
    );

export const valuesDifferences = (a?: object, b?: object) => {
    const result = {};
    if (!a || !b) return result;
    for (const key in a) {
        if (Array.isArray(a[key]) && Array.isArray(b[key])) {
            const updateArray = [...b[key]];

            for (let i = 0; i < a[key].length; i++) {
                if (a[key][i] !== b[key][i]) {
                    updateArray[i] = a[key][i];
                    result[key] = updateArray;
                }
            }
        } else if (typeof a[key] === 'object' && typeof b[key] === 'object') {
            const diff = valuesDifferences(a[key], b[key]);
            if (Object.keys(diff).length > 0) {
                result[key] = diff;
            }
        } else if (a[key] !== b[key]) {
            result[key] = a[key];
        }
    }

    return result;
};
